module.exports = __webpack_public_path__ + "159ffd73f9bb7ae68d59693fbed6ef8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img2_2.jpg
// module id = 540
// module chunks = 0